export default {
  login: 'Логин',
  password: 'Пароль',
  autorizare:'Авторизация',
  forgot_password: 'Я забыл(ла) свой пароль',
  already_have_an_account: 'У меня уже есть аккаунт',
  registration: 'Зарегистрироваться',
}
